import {
  QueryClient,
  QueryErrorResetBoundary,
  QueryClientProvider as RQProvider,
} from "@tanstack/react-query";
import { useEffect } from "react";
import { CF_AUTH_EXPIRED_EVENT } from "@/shared/lib/cf-auth-session";
import { shouldRetryQuery } from "@/shared/lib/query-retry";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 10 * 60_000,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      retry: shouldRetryQuery,
      staleTime: 60_000,
      throwOnError: false,
    },
    mutations: { retry: 0 },
  },
});
export function QueryClientProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    const stopQueries = () => {
      void queryClient.cancelQueries();
    };
    window.addEventListener(CF_AUTH_EXPIRED_EVENT, stopQueries);
    return () => {
      window.removeEventListener(CF_AUTH_EXPIRED_EVENT, stopQueries);
    };
  }, []);

  return (
    <QueryErrorResetBoundary>
      {() => <RQProvider client={queryClient}>{children}</RQProvider>}
    </QueryErrorResetBoundary>
  );
}
